import './ResultsStep.scss';

import React from 'react';

import Alert, { AlertType } from '../../../../../common/Alert';
import bem from '../../../../../utils/bem';
import UploadTagSheetContentWrapper from '../components/UploadTagSheetContentWrapper';
import UploadTagSheetHeader from '../components/UploadTagSheetHeader/UploadTagSheetHeader';
import { useUploadTagSheetContext } from '../UploadTagSheetStepperProvider/UploadTagSheetStepperProvider';
import {
  TAG_SHEET_RESULT_CONFIRM_BUTTON_TEXT,
  TAG_SHEET_RESULT_ERROR_ALERT_MESSAGE,
  TAG_SHEET_RESULT_STEP_TITLE,
} from './constants';
import ResultsSummary from './ResultsSummary';
import ResultsTree from './ResultsTree';

const [block, element] = bem('result-step');

const ResultsStep = (): React.JSX.Element => {
  const { savedTagSheetResult, parseResult } = useUploadTagSheetContext();

  return (
    <div>
      <UploadTagSheetHeader
        title={TAG_SHEET_RESULT_STEP_TITLE}
        confirmButtonDisabled={false}
        confirmText={TAG_SHEET_RESULT_CONFIRM_BUTTON_TEXT}
        hideCancel={true}
      />
      <UploadTagSheetContentWrapper scrollable>
        <div data-testid="result-step" className={block()}>
          {savedTagSheetResult ? (
            <>
              <ResultsSummary lineItems={savedTagSheetResult.lineItems} />
              <ResultsTree lineItems={savedTagSheetResult.lineItems} parseResult={parseResult} />
            </>
          ) : (
            <Alert
              className={element('error')}
              type={AlertType.ERROR}
              bodyText={TAG_SHEET_RESULT_ERROR_ALERT_MESSAGE}
            />
          )}
        </div>
      </UploadTagSheetContentWrapper>
    </div>
  );
};

export default ResultsStep;
